import React from 'react';
import Icofont from 'react-icofont';

export default function Icon({ icon, title, style }) {
    return (<React.Fragment>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </React.Fragment>);
};
